import React from "react";
//import ReactDOM from "react-dom";
import {Amplify} from "aws-amplify";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/redux_store/store";
import { Provider } from "react-redux";
import awsExports from "./config/aws-exports";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import "./index.css";
import { createRoot } from "react-dom/client";
Amplify.configure(awsExports);
let persistor = persistStore(store);

const theme = createTheme();
const container = document.getElementById("root"); const root = createRoot(container); root.render( <React.StrictMode> <ThemeProvider theme={theme}> <Provider store={store}> <PersistGate loading={null} persistor={persistor}> <App /> </PersistGate> </Provider> </ThemeProvider> </React.StrictMode> );
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
